module.exports = __webpack_public_path__ + "img/play_arrow.897b8f71.svg";